export default "__VITE_ASSET__CMFT2k4O__"